import { Shift } from '@wilson/interfaces';

export interface ChangedShiftRecord<T extends Shift> {
  originalShift: T;
  newUserId: string | null;
}

export function generateRecord({
  currentRecords,
  shiftId,
  userId,
  shiftIdToShiftMap,
  originalUserIdToShiftIdsMap,
}: {
  currentRecords: Record<string, ChangedShiftRecord<Shift>>;
  shiftId: string;
  userId: string | null;
  shiftIdToShiftMap: Map<string, Shift>;
  originalUserIdToShiftIdsMap: Record<string, string[]>;
}): Record<string, ChangedShiftRecord<Shift>> {
  const isOriginalAssignment =
    originalUserIdToShiftIdsMap[userId || 'null']?.includes(shiftId);
  let newRecords: Record<string, ChangedShiftRecord<Shift>> = {
    ...currentRecords,
  };

  if (isOriginalAssignment) {
    delete newRecords[shiftId];
  } else {
    const shift = shiftIdToShiftMap.get(shiftId);
    if (shift) {
      newRecords = {
        ...currentRecords,
        [shiftId]: {
          originalShift: shift,
          newUserId: userId,
        },
      };
    }
  }

  return newRecords;
}
